"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageRibbonColor = void 0;
var pageRibbonColor_1 = require("./pageRibbonColor");
Object.defineProperty(exports, "PageRibbonColor", { enumerable: true, get: function () { return __importDefault(pageRibbonColor_1).default; } });
